import { Card, Spin, Tooltip } from 'antd';
import { useTheme } from '../../contexts/useTheme';
import { useStationObservations } from '../../contexts/useStationObservations';
import { useTopBarStation } from '../../contexts/useTopBarStation';

interface TrackTemperatureProps {
  compact?: boolean;
}

export const TrackTemperature: React.FC<TrackTemperatureProps> = ({ compact = false }) => {
  const { theme } = useTheme();
  const { currentWeather, loading, tioLoading, dataSource } = useStationObservations();
  const { topBarStationId } = useTopBarStation();

  const isLoading = dataSource === 'stations' ? loading : tioLoading;
  const trackTemperature = currentWeather.trackTemperature;

  const getDisplayTemp = () => {
    if (isLoading) return '...';
    if (trackTemperature === null || trackTemperature === undefined) return '--';
    return trackTemperature.toFixed(1);
  };

  const card = (
    <Card
      size="small"
      style={{
        background: theme === 'dark' ? '#1f1f1f' : '#f5f5f5',
        border: theme === 'dark' ? '1px solid rgba(255, 255, 255, 0.1)' : '1px solid #d9d9d9',
        minWidth: compact ? '55px' : '80px',
        height: compact ? '32px' : '48px',
      }}
      styles={{ body: { padding: compact ? '2px 6px' : '4px 10px', height: '100%' } }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
        {!compact && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%',
              fontSize: '9px',
              fontWeight: 500,
              color: theme === 'dark' ? 'rgba(255, 255, 255, 0.65)' : 'rgba(0, 0, 0, 0.65)',
              lineHeight: '1.2',
              marginBottom: '2px',
            }}
          >
            <span>Track Temp</span>
            {dataSource === 'stations' && (
              <span style={{ opacity: 0.8 }}>{topBarStationId === 'avg' ? '*' : topBarStationId}</span>
            )}
          </div>
        )}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px' }}>
          <div
            style={{
              fontSize: compact ? '12px' : '16px',
              fontWeight: 600,
              color: theme === 'dark' ? 'white' : 'black',
              lineHeight: '1',
            }}
          >
            {getDisplayTemp()}°C
          </div>
          {isLoading && <Spin size="small" />}
        </div>
      </div>
    </Card>
  );

  return compact ? <Tooltip title="Track Temp">{card}</Tooltip> : card;
};
